import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { OWF_GRANTS_BY_COUNTRY } from "@faire/web-api--source/indigofair/settings/OWF_GRANTS_BY_COUNTRY";

export const useSettingOwFGrant = (): boolean =>
  useSetting(OWF_GRANTS_BY_COUNTRY, false);
